import { W as WuiTooltip$1, d as defineCustomElement$1 } from './p-Cr5d_5Z4.js';

const WuiTooltip = WuiTooltip$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTooltip, defineCustomElement };
